import React, { Suspense } from 'react';
import { Grid, Box } from '@mui/material';
import LazyImage from '../common/LazyImage';
import InstagramIcon from '../../media/site_media/icons/Instagram_icon.webp';
import TwitterIcon from '../../media/site_media/icons/twitter_icon.webp';
import Typography from '@mui/material/Typography';
import { gtag } from 'ga-gtag';

// Import all creator images
import GemmaInfluencerImage from '../../media/site_media/influencer_images/gemma-compressed.webp';
import NicholeImage from '../../media/site_media/influencer_images/nichole.webp';
import KimImage from '../../media/site_media/influencer_images/kim.webp';
import LivImage2 from '../../media/site_media/influencer_images/liv2.webp';
import WilliamImage from '../../media/site_media/influencer_images/williamimage.webp';
import MoveFreeImage from '../../media/site_media/influencer_images/movefree.webp';
import CraftyMomsImage from '../../media/site_media/influencer_images/craftymoms.webp';
import PocketPilatesImage from '../../media/site_media/influencer_images/PocketPilates.webp';
import LisaKayImage from '../../media/site_media/influencer_images/LisaKaye.webp';
import SamanthaMitlingImage from '../../media/site_media/influencer_images/samantha-mitling.webp';
import SohoNutritionImage from '../../media/site_media/influencer_images/soho.webp';
import AstroJoc from '../../media/site_media/influencer_images/astro.webp';
import LindseyWillisImage from '../../media/site_media/influencer_images/LindseyWillis.webp';
import StrongWithEllaImage from '../../media/site_media/influencer_images/strongwithella.webp';
import RecipeRoadImage from '../../media/site_media/influencer_images/recipe-road.webp';
import JoeyImage from '../../media/site_media/influencer_images/joeybronston.webp';
import AbiMillsImage from '../../media/site_media/influencer_images/abi-mills.webp';
import KatiePierceImage from '../../media/site_media/influencer_images/katiepierce-Pilatesanywhereanytime.webp';
import SlimmingTeganImage from '../../media/site_media/influencer_images/slimmingtegan.webp';
import EmmaDiariesImage from '../../media/site_media/influencer_images/emma-diaries.webp';
import MarfsKitchenGardenImage from '../../media/site_media/influencer_images/marfskitchengarden-824k.webp';
import KetomadesimpleImage from '../../media/site_media/influencer_images/ketomadesimple-608k.webp';

const gemma_count = '239K Followers';
const pocketpilates_count = '10.6K Followers';
const samanthamitling_count = '213K Followers';
const livthepositivefoodie_count = '285K Followers';
const livingasnichole_count = '80K Followers';
const movefree_count = '42K Followers';
const kimberlysjourney_count = '142K Followers';
const Strongwithella_count = '46.4K Followers';
const williamtrubridge_count = '162K Followers';
const astrojoc_count = '110K Followers';  
const soho_count = '167K Followers';
const recipe_road_count = '355K Followers';

const joey_count = '306K Followers';
const abimills_count = '241K Followers';
const katiepierce_count = '320K Followers';
const slimmingtegan_count = '90K Followers';
const lisakaye_count = '345K Followers';
const emmadiaries_count = '22.4K Followers';
const marfs_count = '824K Followers';
const ketomadesimple_count = '608K Followers';



const LazySlideImage = ({ src, ...rest }) => (
   <Suspense fallback={<div></div>}>
      <LazyImage src={src} {...rest} />
   </Suspense>
);

const creatorData = [

    {
       name: 'Samantha Mitling',
       image: SamanthaMitlingImage,
       category: 'Martial Arts',
       description: "A world champion martial artist, Samantha aims to help bring your bo staff skills to the next level",
       count: samanthamitling_count,
       socialType: 'instagram',
       url: 'SamanthaMitling'
    },
    {
       name: 'Gemma',
       image: GemmaInfluencerImage,
       category: 'Food Creator',
       description: "Creating recipes and meal plans to prove that dieting and losing weight doesn't have to be boring!",
       count: gemma_count,
       socialType: 'instagram',
       url: 'gemma'
    },
    {
       name: 'William',
       image: WilliamImage,
       category: 'World Record Free Diver',
       description: 'World record-holding unassisted freediver & founder of Vertical Blue Freediving School & Event.',
       count: williamtrubridge_count,
       socialType: 'instagram',
       url: 'williamtrubridge'
    },
 
 
    {
       name: 'Lindsey Willis',
       image: LindseyWillisImage,
       category: 'Food Creator',
       description: "Recreating your favorite meals with fewer calories to show that no food needs to be off-limits.",
       count: '137K Followers',
       socialType: 'instagram',
       url: 'slimminggymandgin'
    },
    {
       name: 'Katie Pierce',
       image: KatiePierceImage,
       category: 'Pilates',
       description: "Enjoy exclusive workout content to help you feel your best, reach your goals and enhance your Pilates practice.",
       count: katiepierce_count,
       socialType: 'instagram',
       url: 'Pilatesanywhereanytime'
    },
    {
       name: 'Soho Nutrition',
       image: SohoNutritionImage,
       category: 'Food & Nutrition',
       description: 'As a certified nutritionist, Sophie will help you build a healthy relationship with food.',
       count: soho_count,
       socialType: 'instagram',
       url: 'sohonutrition'
    },
 
    {
       name: 'Joey Bronston',
       image: JoeyImage,
       category: 'Fitness',
       description: "Join Joey for some intense workouts that push your limits paired with a dash of humor and fun.",
       count: joey_count,
       socialType: 'instagram',
       url: ''
    },
    {
       name: 'Recipe Road',
       image: RecipeRoadImage,
       category: 'Food & Recipes',
       description: 'Petya is all about creating & sharing easy, delicious and high protein recipes that are good for you.',
       count: recipe_road_count,
       socialType: 'instagram',
       url: 'reciperoad'
    },
    {
       name: 'Astrojoc',
       image: AstroJoc,
       category: 'English Teacher',
       description: 'Join Astro Joc to develop learning habits and overcome the fear of speaking English.',
       count: astrojoc_count,
       socialType: 'twitter',
       url: 'Astrojoc'
    },
    {
       name: 'Lisa Kaye',
       image: LisaKayImage,
       category: 'Pilates',
       description: "Lisa aims to help everyone feel stronger and more confident as they move through Pilates.",
       count: lisakaye_count,
       socialType: 'instagram',
       url: 'lisakayepilates'
    },
 
    // {
    //    name: 'Living As Nicole',
    //    image: NicholeImage,
    //    category: 'Food Creator',
    //    description: "A busy mom who lost 50+ pounds with mindset & calorie counting. Now she helps others do the same.",
    //    count: livingasnichole_count,
    //    socialType: 'instagram',
    //    demo: false,
    //    url: 'livingasnichole'
    // },
    {
       name: 'Liv',
       image: LivImage2,
       category: 'Food Creator',
       description: "Olivia's platform is all about embracing good food, positive energy, and striving for the happiest self with others.",
       count: livthepositivefoodie_count,
       socialType: 'instagram',
       url: 'livthepositivefoodie'
    },
    // {
    //    name: 'Move Free',
    //    image: MoveFreeImage,
    //    category: 'Pilates',
    //    description: "Your online home for mindful movement. With Charlotte Holmes & top guest instructors.",
    //    count: movefree_count,
    //    socialType: 'instagram',
    //    url: 'movefree'
    // },
 
    {
       name: 'Emma Diaries',
       image: EmmaDiariesImage,
       category: 'Food Creator',
       description: "Emma is all about empowering you to embrace a more body-positive mindset while achieving your health goals.",
       count: emmadiaries_count,
       socialType: 'instagram',
       url: 'EmmaDiaries'
    },
    {
       name: 'Strong With Ella',
       image: StrongWithEllaImage,
       category: 'Food Creator',
       description: "Ella's goal is to help as many people as possible to lead a healthy, active lifestyle without the sacrifices.",
       count: Strongwithella_count,
       socialType: 'instagram',
       demo: false,
       url: 'Strongwithella'
    },
    {
       name: 'Pocket Pilates',
       image: PocketPilatesImage,
       category: 'Pilates',
       description: 'Enjoy exclusive access to spicy, soulful & specialized Pilates, helping you to look good & feel great!',
       count: pocketpilates_count,
       socialType: 'instagram',
       url: 'pocketpilates'
    },
    {
       name: 'Slimming Tegan',
       image: SlimmingTeganImage,
       category: 'Food Creator',
       description: "Quick & easy calorie-counted recipes, along with a daily food blog and diary to support your health journey.",
       count: slimmingtegan_count,
       socialType: 'instagram',
       url: 'slimmingtegan'
    },
 
    {
       name: 'Abi Mills',
       image: AbiMillsImage,
       category: 'Yoga & Comedy',
       description: "Abi brings a unique twist to health and wellness with her blend of yoga and comedy.",
       count: abimills_count,
       socialType: 'instagram',
       url: 'abimillsyoga'
    },
 
    // {
    //    name: 'Martha Swales',
    //    image: MarfsKitchenGardenImage,
    //    category: 'Food Creator',
    //    description: "Marfs Kitchen Garden is all about food, flowers & wildlife. Join Marfs for easy gardening projects.",
    //    count: marfs_count,
    //    socialType: 'instagram',
    //    url: 'marfskitchengarden'
    // },
 
    {
       name: 'Keto Made Simple',
       image: KetomadesimpleImage,
       category: 'Food Creator',
       description: "Julie has inspired thousands with her weight loss journey and educates others on the keto diet journey.",
       count: ketomadesimple_count,
       socialType: 'instagram',
       url: 'ketomadesimple'
    },
 
    {
       name: 'Kim',
       image: KimImage,
       category: 'Weight Loss',
       description: 'Dedicated to proving that weight loss can be enjoyable, she embarks on her journey to help others reach their goals.',
       count: kimberlysjourney_count,
       socialType: 'instagram',
       url: 'kimberlysjourney'
    },
 
    {
       name: 'Crafty Moms',
       image: CraftyMomsImage,
       category: 'Kids Education',
       description: 'Sensory play lovers & upcycling enthusiasts. Sharing mom hacks and our mom life journey. Join the fun!',
       count: '1.9M Followers',
       socialType: 'instagram',
       url: 'craftymoms'
    },
]

const styles = {
  container: {
    width: '100%',
    justifyContent: 'space-between',
  },
  gridContainer: {
    justifyContent: 'space-between',
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    flexWrap: { xs: 'nowrap', md: 'wrap' },
    gap: { xs: '25px', md: '40px 25px' },
    alignItems: 'center',
  },
  card: {
    height: '380px',
    width: '280px', // Increased width
    borderRadius: '12px',
    position: 'relative',
    textAlign: 'center', 
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-8px)', // Increased lift on hover
    },
  },
  imageContainer: {
    height: '230px',
    width: '100%',
    position: 'relative',
    borderTopLeftRadius: '12px', // Matching card radius
    borderTopRightRadius: '12px',
    overflow: 'hidden', // Ensures image respects border radius
  },
  gradient: {
    position: 'absolute',
    left: '0',
    bottom: '135px',
    width: '100%',
    height: '100px',
    background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 1) 100%)'
  },
  cardContent: {
    padding: '30px', // Increased padding
    position: 'absolute',
    bottom: '20px',
    width: '100%',
  },
  category: {
    fontSize: '10px',
    fontWeight: '800',
    color: 'var(--brand-color)',
    textTransform: 'uppercase',
    margin: '0 0 4px 0',
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#222222',
    textTransform: 'uppercase',
    margin: '0',
  },
  description: {
    fontSize: '12px',
    color: '#6E89AF',
    margin: '12px 0', // Increased margin
  },
  socialStats: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '600',
    color: '#000',
    textTransform: 'uppercase',
  },
};

const cardHeight = 380;
const cardWidth = 230;
const gradientOffset = 135;

const cardStyle = {
   height: cardHeight,
   width: cardWidth,
   borderRadius: '12px',
   position: 'relative',
   textAlign: 'center',
   backgroundColor: '#fff',
   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
   transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
   '&:hover': {
     transform: 'translateY(-8px)',
     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
   },
}

const cardTitle = {
   fontSize: '18px',
   fontWeight: '600',
   color: '#222222',
   textTransform: 'uppercase',
   margin: '0px',
   padding: '0 15px', // Added padding
}

const cardCategory = {
   fontSize: '10px',
   fontWeight: '800',
   color: 'var(--brand-color)',
   textTransform: 'uppercase',
   margin: '0px 0px 4px 0px',
}

const cardDescription = {
   fontSize: '12px',
   color: '#6E89AF',
   margin: '12px 0px',
   padding: '0 20px', // Added padding
}



const CreatorCard = ({ creator }) => (
  <Box
    onClick={() => {
      gtag('event', 'landing_page_example_clicks', {
        'event_category': 'Landing Page Example Click',
        'event_label': 'Landing Page Example Click'
      });
      if (creator.url !== '') {
        window.open('/' + creator.url.toString(), "_blank");
      }
    }}
    sx={{
      ...cardStyle,
      cursor: creator.url !== '' ? 'pointer' : 'default',
      transition: 'transform 0.2s ease-in-out',
      border: '1px solid #E4EBF6',
      '&:hover': {
        transform: 'translateY(-8px)'
      }
    }}
  >
    <div className="border-0 partner-card" style={{ width: '100%', height: '100%' }}>
      <div className="card-img-top border-0 partner-card-header" style={{
        height: '100%',
        border: 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        overflow: 'hidden'
      }}>
        <div style={{
            height: '230px',
            width: '230px',
            position: 'relative',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            overflow: 'hidden'
        }}>
           <LazySlideImage
          src={creator.image}
          style={{
            width: '100%',
            height: '100%',
            minHeight: '230px',
            minWidth: '230px',
            objectFit: 'cover',
            objectPosition: 'center',
            position: 'absolute',
            top: '0',
            left: '0',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px'
          }}
        />
        </div>
        
        <div style={{
          position: 'absolute',
          left: '0',
          bottom: gradientOffset,
          width: '100%',
          height: '100px',
          background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 1) 100%)'
        }}></div>
      </div>
    </div>

    <div className="card-body pt-2" style={{
      height: '30%',
      width: '100%',
      position: 'absolute',
      bottom: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0' // Added padding
    }}>
      <p style={cardCategory}>{creator.category}</p>
      <p style={cardTitle}>{creator.name}</p>
      <p style={cardDescription}>{creator.description}</p>
      {creator.count === '' ? (
        <div style={{display: 'flex', alignItems: 'center', fontSize: '14px', fontWeight: '500', color: '#000'}}>
          <p>Coming Soon</p>
        </div>
      ) : (
        <p style={{display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '600', color: '#000', textTransform: 'uppercase', margin: '0px 0px 5px 0px'}}>
          <img 
            src={creator.socialType === 'instagram' ? InstagramIcon : TwitterIcon} 
            alt="socials" 
            style={{ marginRight: '5px', verticalAlign: 'middle', width: '18px', height: '18px' }} 
          />
          {creator.count}
        </p>
      )}
    </div>
  </Box>
);

const ExampleCreators = ({ windowWidth, exampleModal, sectionHeader, mainHeader, mainDescription }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.gridContainer}>
        {creatorData.map((creator, index) => (
          <CreatorCard key={index} creator={creator} />
        ))}
      </Box>
    </Box>
  );
};

export default ExampleCreators;
